import t from 'prop-types';
import { PublicProfilePage } from '../../components/publicProfile/PublicProfilePage'
import axios from 'axios';

const PublicProfile = ({
  profile, memberStats, timeline
}) => {

  return (<PublicProfilePage profile={profile} memberStats={memberStats} timeline={timeline} />);
};

PublicProfile.propTypes = {
  profile: t.shape({}),
  memberStats: t.shape({}),
  timeline: t.array
};

const getPublicProfile = (slugOrId) => {
  return axios.get(`${process.env.API_PREFIX_AT_WORK}/public/profile/${slugOrId}/`)
    .then((response) => response.data.profile)
}

const getTimeline = (slugOrId) => {
  return axios.get(`${process.env.API_PREFIX_AT_WORK}/public/profile/${slugOrId}/timeline`)
    .then((response) => response.data.timeline)
}

const getMemberStats = (slugOrId, experienceRecordToggle) => {
  const endpoint = experienceRecordToggle
  ? `${process.env.AT_WORK_API}/v2/public/profile/${slugOrId}/stats`
  :`${process.env.API_PREFIX_AT_WORK}/public/profile/${slugOrId}/stats`

return axios.get(endpoint)
    .then((response) => response.data.stats)
}

export async function getServerSideProps(context) {
  const slugOrId = context?.query?.id;
  const experienceRecordToggle = context?.query['experience-records'] === 'true';

  if (!slugOrId || slugOrId === 'undefined') throw Error("Missing query parameter: slugOrId")

  try {
    const [profile, timeline, memberStats] = await Promise.all([
      getPublicProfile(slugOrId),
      getTimeline(slugOrId),
      getMemberStats(slugOrId, experienceRecordToggle)
    ])

    const props = { profile, memberStats, timeline };

    return {
      props
    }
  } catch (error) {
    if (error?.response?.status === 404) {
      return { notFound: true }
    }
    throw error
  }

}

export default PublicProfile;
